import React, {KeyboardEvent, useContext, useState} from 'react';
import {Button, Flex, Icon, Input, ToolbarIcons} from '@priority-software/priority-style-react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {ADD_LINK_COMMAND} from '../../../commands';
import keyCodes from '../../../../../constants/KeyCodes';
import {TollbarTextsContext} from '../Toolbar/TollbarText.context';
import styles from './LinkDialog.module.scss';
import {isRTL} from '../../../../../Localization';

type Props = {
    onClose: () => void;
    defaultUrl?: string;
    defaultText?: string;
    update: boolean;
};

const iconStyles = isRTL() ? {marginRight: 8} : {marginLeft: 8};

export const LinkDialog = ({defaultUrl, defaultText, onClose, update = false}: Props) => {
    const [linkURL, setLinkURL] = useState(defaultUrl);
    const [linkText, setLinkText] = useState(defaultText);
    const [editor] = useLexicalComposerContext();
    const texts = useContext(TollbarTextsContext);

    const onSubmit = () => {
        editor.dispatchCommand(ADD_LINK_COMMAND, {
            text: linkText || linkURL,
            url: linkURL,
            update
        });
        onClose();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.keyCode === keyCodes.ENTER) {
            e.preventDefault();
            e.stopPropagation();
            onSubmit();
        }
    };

    return (
        <div className={styles.component}>
            <Input
                prefixIcon={<Icon style={iconStyles} icon={ToolbarIcons.toolbarTextIcon} />}
                label={<span className="pui-label-required">{texts.link_dialog_text_label}</span>}
                componentClasses={styles.input}
                placeholder={texts.link_dialog_text_placeholder}
                value={linkText}
                onKeyDown={handleKeyDown}
                size="xlarge"
                onChange={e => setLinkText(e.target.value)}
            />

            <Input
                autoFocus
                prefixIcon={<Icon style={iconStyles} icon={ToolbarIcons.toolbarLinkChain} />}
                componentClasses={styles.input}
                label={<span className="pui-label-required">{texts.link_dialog_link_label}</span>}
                placeholder={texts.link_dialog_link_placeholder}
                value={linkURL}
                size="xlarge"
                onKeyDown={handleKeyDown}
                onChange={e => setLinkURL(e.target.value)}
            />

            <Flex justifyContent="flex-end">
                <Button
                    wideButton
                    disabled={!linkURL}
                    size="large"
                    skin="primary"
                    onClick={onSubmit}
                >
                    {defaultUrl ? texts.save_btn_title : texts.dialog_add_btn_label}
                </Button>
            </Flex>
        </div>
    );
};
